import { Grid } from "@material-ui/core";
import FilterListIcon from "@material-ui/icons/FilterList";
import { PatientManagementStore } from "app/PatientManagement/PatientManagementStore";
import { useStore } from "app/stores";
import { Form, Formik } from "formik";
import { observer } from "mobx-react";
import { memo, useEffect, useState } from "react";
import ListComplaint from "./ListComplaint";
import SearchComplaint from "./SearchComplaint";

const ComplaintIndex = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");
  const { searchComplaint, handleChangeFormSearchComplaint } =
    PatientManagementStore.complaintStore;
  const { initialPatient } =
    useStore().patientManagementStore.patientGeneralStore;
  const [isOpenFillter, setOpenFillter] = useState(true);
  useEffect(() => {
    // Nếu có patientId và đã có dữ liệu patientInfo (từ initialPatient)
    if (patientId && initialPatient?.patientInfo?.code) {
      const clientCode = initialPatient.patientInfo.code;
      handleChangeFormSearchComplaint({
        ...searchComplaint,
        clientCode,
      });
    } else {
      handleChangeFormSearchComplaint({
        ...searchComplaint,
      });
    }
  }, [patientId]);

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={6}>
        <div
          className=" flex justify-between gap-2"
          style={{ fontSize: "16px" }}
        >
          <span
            className="cards-header flex items-center pointer"
            style={{ fontWeight: "bold", padding: "10px" }}
          >
            Khiếu nại
            <FilterListIcon
              style={{ marginRight: 8, cursor: "pointer" }}
              onClick={() => setOpenFillter(!isOpenFillter)}
            />
          </span>
        </div>
      </Grid>
      <Grid item xs={12} sm={6}>
        {isOpenFillter && (
          <>
            <style>
              {`
                        @keyframes slideDownFade {
                        0% {
                            opacity: 0;
                            transform: translateY(-10px);
                        }
                        100% {
                            opacity: 1;
                            transform: translateY(0);
                        }
                        }
                    `}
            </style>
            <div
              style={{
                animation: "slideDownFade 0.3s ease forwards",
              }}
            >
              <Formik
                initialValues={searchComplaint}
                onSubmit={(values) => {
                  handleChangeFormSearchComplaint(values);
                }}
                enableReinitialize
              >
                <Form autoComplete="off">
                  <SearchComplaint />
                </Form>
              </Formik>
            </div>
          </>
        )}
      </Grid>
      <Grid item xs={12}>
        <ListComplaint />
      </Grid>
    </Grid>
  );
};

export default memo(observer(ComplaintIndex));
